import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, signal, ViewChild, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Align, Margin } from '@progress/kendo-angular-popup';
import "@progress/kendo-date-math/tz/all";

import * as fromStore from '@src/app/store/conventional';
import { PopupComponent } from '../popup.component';

import { LogoutOnlyMenuComponent } from "@src/app/core/components/logout-only-menu/logout-only-menu.component";

@Component({
    selector: 'cs-logout-only-popup',
    imports: [
        CommonModule,
        ButtonModule,
        IconsModule,
        PopupComponent,
        LoaderModule,
        LayoutModule,
        ButtonsModule,
        DropDownsModule,
        LogoutOnlyMenuComponent
    ],
    template: `
    <cs-popup #anchor class="md:w-[298px]" [position]="popupPosition()" [margin]="popupMargin()">
      <kendo-avatar csPopupAnchorContent shape="circle" class="size-8"></kendo-avatar>

      <div csPopupPanelContent>
        <cs-logout-only-menu (logout)="handleLogout()"></cs-logout-only-menu>
      </div>
    </cs-popup>
  `
})
export class LogoutOnlyPopupComponent {
  private store = inject(Store<fromStore.State>);

  @ViewChild('anchor', { static: true }) anchor: ElementRef | undefined;
  // public user = input<User>();
  public popupPosition = signal<Align>({ vertical: 'top', horizontal: 'center' })
  public popupMargin = signal<Margin>({ horizontal: 118, vertical: 7 })

  public handleLogout() {
    (this.anchor as unknown as { showPopup: WritableSignal<boolean> })?.showPopup?.set(false);
    this.store.dispatch(fromStore.logoutConfirmed());
  }
}
